import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "integration-support";

export type IntegrationSupportChatResponse = AgentChatResponse;

export async function createIntegrationSupportSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingIntegrationSupportSession(
  sessionId: string,
): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamIntegrationSupportMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<IntegrationSupportChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Integration support agent error",
  );
}
